/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { useViewport } from '@vlinder-web/viewport-provider-react';

import {
  ChatWithUs,
  IChatWithUsProps,
  ContactUsForm,
  IContactUsFormProps,
  FaqContainer,
  IFaqContainerProps,
  TeamSection,
  ITeamSectionProps,
} from './components';
import ImageSliderVW from './components';
type IContactUsPageType = IChatWithUsProps &
  IContactUsFormProps &
  IFaqContainerProps &
  ITeamSectionProps;

export const ContactUsPage = ({ ...rest }: IContactUsPageType) => {
  const { bp, width } = useViewport();
  console.log('AsirFaqConfigrest', rest?.faqConfig);
  return (
    <div className='bg-gray-100'>
      <ContactUsForm {...rest} />
      <ChatWithUs {...rest} />
      <FaqContainer
          faqConfig={
          rest?.faqConfig?.questions
        }
      />
      <TeamSection {...rest} />
    </div>
  );
};

ContactUsPage.defaultProps = {};
